import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.08048 11.1924V5.12512L4.71819      7.48742L3.82715 6.60908L7.70527 2.73096L11.5836 6.60908L10.6926 7.48742L8.33027 5.12512V11.1924H7.08048ZM12.4409 18.5643L8.56277 14.6862L9.45381 13.8078L11.8159 16.1701V10.1028H13.0659V16.1701L15.4282       13.8078L16.319 14.6862L12.4409 18.5643Z",
		fill: "currentColor"
	})
});
export default SvgSwap;
